<template>
  <drafts
    :items="edits"
    :loading="loading"
    :count="count"
    :page-size="pageSize"
    @filter-changed="onFilterChanged"
    @search="editSearch"
    @pageChange="onPageChange"
    @refresh="onRefresh"
  />
</template>

<script>
import _ from 'lodash';
import Drafts from './Drafts';

export default {
  name: 'DraftsContainer',

  components: {
    Drafts,
  },

  props: {
    pageSize: {
      type: Number,
      default: 10,
    },
  },

  data() {
    return {
      page: 1,
      filter: '',
      search: '',
    };
  },

  computed: {
    count() {
      return this.$store.state.entries.count;
    },
    edits() {
      return this.$store.state.entries.items.slice();
    },
    loading() {
      return this.$store.state.entries.isLoading;
    },
  },

  watch: {
    search: _.debounce(function searchEdits() {
      this.$store.dispatch('entries/reset');
      this.fetchData();
    }, 200),

    count(count) {
      if (count) {
        if (count % this.pageSize === 0 && this.page > count / this.pageSize) {
          this.page = count / this.pageSize;
        }
        this.pushRoute({ page: this.page, filter: this.filter });
        this.fetchData();
      }
    },
  },

  mounted() {
    const { page, filter } = this.$route.query;
    this.page = page || 1;
    this.filter = filter;

    this.pushRoute({ page: this.page, filter: this.filter });
    this.fetchData();
  },

  methods: {
    editSearch(search) {
      this.search = search;
      this.page = 1;
    },

    fetchData() {
      const reqParams = {
        page: this.page,
        page_size: this.pageSize,
        search: this.search,
      };
      if (typeof this.filter !== 'undefined') {
        reqParams.sent = this.filter;
      }

      this.$store.dispatch('entries/fetchAll', reqParams);
    },

    pushRoute(query) {
      window.scroll({ top: 0, left: 0 });

      if (query.filter === undefined) {
        delete query.filter;
      }

      this.$router
        .push({
          path: this.$route.path,
          query,
        })
        .catch(() => {
          // Avoid "avoid redundant navigation" warning
        });
    },

    onPageChange(page) {
      this.page = Math.max(1, page);
      this.pushRoute({ page: this.page, filter: this.filter });
      this.fetchData();
    },

    onFilterChanged(sent) {
      this.page = 1;
      this.filter = sent;

      this.pushRoute({ page: this.page, filter: this.filter });
      this.fetchData();
    },

    onRefresh() {
      this.$store.dispatch('entries/reset');
      this.fetchData();
    },
  },
};
</script>
<style lang="css" scoped></style>
